module.exports = __webpack_public_path__ + "img/qsignLogo.34f4426c.svg";